import { Component, EventEmitter, Inject, Input, Output, PLATFORM_ID } from '@angular/core';
import { environment } from 'projects/lime-main/src/environments/environment';
import { ViewportService } from '@shared/common/services/viewport/viewport.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-empty-data-banner',
  templateUrl: './empty-data-banner.component.html',
  styleUrls: ['./empty-data-banner.component.scss'],
  standalone: false
})
export class EmptyDataBannerComponent {
  @Input() imageUrl = '';
  @Input() title = '';
  @Input() description = '';
  @Input() actionLabel = '';
  @Input() actionIcon = '';
  @Input() orientation: 'auto' | 'vertical' | 'horizontal' = 'auto';
  @Output() actionClicked: EventEmitter<void> = new EventEmitter();

  get imagePath(): string {
    return environment.imgixHost + this.imageUrl;
  }

  get isMobile(): boolean {
    if (isPlatformBrowser(this.platformId)) {
      return this.viewportService.isMobileDevice();
    }
    return true;
  }

  constructor(
    private readonly viewportService: ViewportService,
    @Inject(PLATFORM_ID) public platformId: Object
  ) {}

  onActionClicked(): void {
    this.actionClicked.emit();
  }
}
